import { api } from './api.service';
import {
  ICreatePrescriptionTemplatePayload,
  IPrescriptionTemplate,
  IUpdatePrescriptionTemplatePayload,
  TemplateFieldType,
} from '../interfaces/IPrescriptionTemplate';

export async function listPrescriptionTemplates(type?: TemplateFieldType): Promise<IPrescriptionTemplate[]> {
  const { data } = await api.get('/prescription-templates', { params: type ? { type } : undefined });
  return data;
}

export async function createPrescriptionTemplate(
  payload: ICreatePrescriptionTemplatePayload,
): Promise<IPrescriptionTemplate> {
  const { data } = await api.post('/prescription-templates', payload);
  return data;
}

export async function updatePrescriptionTemplate(
  id: string,
  payload: IUpdatePrescriptionTemplatePayload,
): Promise<IPrescriptionTemplate> {
  const { data } = await api.put(`/prescription-templates/${id}`, payload);
  return data;
}

export async function deletePrescriptionTemplate(id: string): Promise<void> {
  await api.delete(`/prescription-templates/${id}`);
}
